//Margin conventions
var margin = {top: 10, right: 3, bottom: 30, left: 55};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 300 - margin.top - margin.bottom;

//Parses date for correct time format
var parseDate = d3.time.format("%Y").parse;  

//Add commas
var commaFormat = d3.format("0,000");

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
	.attr("width", width + margin.left + margin.right)
	.attr("height", height + margin.top + margin.bottom)
	.append("g")
	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.time.scale()
  .range([0, width]);

//Creates the yScale
var yScale = d3.scale.linear()
  .range([height, 0]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
	.scale(yScale)
  .tickSize(-width)
  .tickPadding(8)
  .ticks(5)
  .tickFormat(function(d) { return commaFormat(d); })
	.orient("left");

//Defines the y axis styles
var xAxis = d3.svg.axis()
	.scale(xScale)
  .tickPadding(8)
	.orient("bottom")
  .ticks(4)
  .tickFormat(d3.time.format("%Y")); 

//line function convention (feeds an array)
var line = d3.svg.line()
  .x(function(d) { return xScale(d.date); })
  .y(function(d) { return yScale(d.amount); }); 

//area function
//var area = d3.svg.area()
//  .x(function(d) {return xScale(d.date); }) 
//  .y0(height)  
//  .y1(function(d) {return yScale(d.amount); });    

//Loads the data
d3.csv("data/opioidDrugs.csv", ready);

function ready(err, data) {

	if (err) throw "error loading data";

	//FORMAT data
	data.forEach(function(d) {
		d.amount = +d.amount;
    d.date = parseDate(d.date);
	});
	
	//Organizes the data	
  data.sort(function(a,b) { return a.date - b.date; });
  var maxY = d3.max(data, function(d) { return d.amount; });
  var maxX = d3.max(data, function(d) { return d.date; });

  //Nest the data
  var dataByDrug = d3.nest()
    .key(function(d) { return d.drug;})
    .entries(data);

  console.log(dataByDrug);  

  //Defines the xScale max
  xScale.domain(d3.extent(data, function(d) { return d.date; }));

  //Defines the yScale max
  yScale.domain([0, d3.max(data, function(d) { return d.amount; })]);

	//Appends the y axis
	var yAxisGroup = svg.append("g")
		.attr("class", "y axis")
		.call(yAxis)
		.selectAll("g")
		.classed("g-baseline", function(d) {return d == 0});

	//Appends the x axis		
	var xAxisGroup = svg.append("g")
		.attr("class", "x axis")
		.attr("transform", "translate(0," + height + ")")
		.call(xAxis);   

  //Binds the data to the line
  var drawline = svg.selectAll(".cat-path")
    .data(dataByDrug)
    .enter()
    .append("path")
    .attr("class", "cat-path")
    .attr("d", function(d) { return line(d.values) })
    .classed("Oxycodone-line", function(d) { return d.key == "Oxycodone"; })
    .classed("Hydrocodone-line", function(d) { return d.key == "Hydrocodone"; })
    .classed("Codeine-line", function(d) { return d.key == "Codeine"; })
    .classed("Morphine-line", function(d) { return d.key == "Morphine"; });  


  //Append labels  
  var Oxycodonelabel = svg.append("text")
      .text("Oxycodone")
      .attr("class", "Oxycodone-label")
      .attr("x", width/1.7)
      .attr("y", height/7);    

  var Hydrocodonelabel = svg.append("text")
      .text("Hydrocodone")
      .attr("class", "Hydrocodone-label")
      .attr("x", width/1.065)
      .attr("y", height/3.2);     

  var Codeinelabel = svg.append("text")
      .text("Codeine")
      .attr("class", "Codeine-label")
      .attr("x", width/2)
      .attr("y", height/1.225); 

  var Morphinelabel = svg.append("text")
      .text("Morphine")
      .attr("class", "Morphine-label")
      .attr("x", width/1.55)
      .attr("y", height/1.8);                	

//RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 10, right: 3, bottom: 30, left: 55};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Update the line
    line = d3.svg.line()
      .x(function(d) { return xScale(d.date); })
      .y(function(d) { return yScale(d.amount); }); 

    d3.selectAll('.cat-path')
      .attr("d", function(d) { return line(d.values) }) 

    //Updates xAxis
    d3.selectAll(".x.axis")
         .call(xAxis);     

    //Updates ticks
    xAxis
      .scale(xScale)
      .ticks(4);

    //Updates yAxis
    d3.selectAll(".y.axis")
      .call(yAxis); 

    yAxis
      .tickSize(-newWidth);

    Oxycodonelabel
      .attr("x", newWidth/1.7);  

    Hydrocodonelabel
      .attr("x", newWidth/1.065); 

    Codeinelabel
      .attr("x", newWidth/2);  

    Morphinelabel
      .attr("x", newWidth/1.55);      
  };

}